import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=c08a53a6&scoped=true"
import script from "./ChannelList.vue?vue&type=script&lang=js"
export * from "./ChannelList.vue?vue&type=script&lang=js"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=c08a53a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08a53a6",
  null
  
)

export default component.exports